(function () {
  const form    = document.getElementById('HeroWaitlistForm');
  const input   = document.getElementById('HeroEmailInput');
  const btn     = document.getElementById('HeroSubmitBtn');
  const btnText = btn.querySelector('.hs-hero__btn-text');
  const spinner = btn.querySelector('.hs-hero__btn-spinner');

  let alertTimer = null;

  function isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim());
  }

  function showAlert(type, msg) {
    if (alertTimer) clearTimeout(alertTimer);

    let alertBox = document.getElementById('HeroFormAlert');
    if (!alertBox) {
      alertBox = document.createElement('div');
      alertBox.id = 'HeroFormAlert';
      form.insertAdjacentElement('afterend', alertBox);
    }

    alertBox.style.transition = 'none';
    alertBox.style.opacity    = '1';
    alertBox.className        = `alert alert-${type} mt-3`;
    alertBox.textContent      = msg;
    alertBox.classList.remove('d-none');

    alertTimer = setTimeout(() => {
      alertBox.style.transition = 'opacity 0.4s ease';
      alertBox.style.opacity    = '0';
      setTimeout(() => alertBox.classList.add('d-none'), 400);
    }, 3000);
  }

  function resetForm() {
    input.value    = '';
    input.disabled = false;
    input.classList.remove('is-invalid');
    btn.disabled   = false;
    btnText.textContent = 'Join the waitlist';
    btnText.classList.remove('d-none');
    spinner.classList.add('d-none');
  }

  function setLoading(on) {
    btn.disabled = on;
    btnText.classList.toggle('d-none', on);
    spinner.classList.toggle('d-none', !on);
  }

  input.addEventListener('input', () => {
    input.classList.remove('is-invalid');
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const email = input.value.trim();

    if (!isValidEmail(email)) {
      input.classList.add('is-invalid');
      showAlert('danger', 'Please enter a valid email address.');
      return;
    }

    setLoading(true);

    try {
        const formData = new FormData(form);

        const response = await fetch(window.location.pathname, {
            method: 'POST',
            body: formData,
            headers: {
            'Accept': 'text/html, */*',
            'X-Requested-With': 'XMLHttpRequest'
            }
        });

        const html = await response.text();

        // If the response contains form errors, Shopify re-renders the form
        // If submission succeeded, the form is gone from the response
        const hasError = html.includes('form-status') ||
                        html.includes('error') && html.includes('contact[email]');

        if (!hasError) {
            showAlert('success', "You're on the list. We'll be in touch soon.");
            setTimeout(resetForm, 3400);
        } else {
            // Parse the actual Shopify error from the response
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const errorEl = doc.querySelector('.form-status, .customer-form-errors, [data-form-error]');
            const errorMsg = errorEl?.textContent?.trim() || 'Something went wrong. Please try again.';
            showAlert('danger', errorMsg);
            setTimeout(resetForm, 3400);
        }

        } catch {
        showAlert('danger', 'Something went wrong. Please try again.');
        setTimeout(resetForm, 3400);
        }
  });

})();